import { Component, EventEmitter, inject, Input, Output, SimpleChanges, OnInit, OnChanges, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import * as _ from 'lodash';

import { HisColumnMetadata } from '../model/his-column-metadata';
import { HisSearchResultRow } from '../model/his-search-result';
import { HisUiService } from '../../core/service/base/his-ui.service';

@Component( {
    selector: 'his-search-result-table-cell',
    templateUrl: './his-search-result-table-cell.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisSearchResultTableCellComponent implements OnInit, OnChanges {
    @Input({required: true}) rowId: any;
    @Input({required: true}) row: any;
    @Input({required: true}) column: HisColumnMetadata;
    @Input( { required: true } ) columnIndex: any;

    @Input() ri: any;

    // if given then the default action column is rendered by this template
    @Input() defaultAction: TemplateRef<{ index: number; row: HisSearchResultRow }>;
    
    // if the defaultAction template is not given then we use these informations to render the default action column
    @Input() defaultActionRoute: string;
    @Input() defaultActionRouteQueryParams: any;
    @Input() defaultActionUrl: string;
    
    @Input() showBackButton: boolean;
    @Input() isDefaultColumn = false;
    @Input() defaultActionToolTip: string;
    @Input() defaultActionRowRight: string;

    protected columnContent: string;
    protected disableDefaultActionLink: any;


    // metadata describing the columns of the search result
    @Output() beforeNavigateDefaultRoute: EventEmitter<any> = new EventEmitter();

    private uiService = inject( HisUiService );

    ngOnInit() {
        this.columnContent = this.row.getAt( this.columnIndex );
        this.disableDefaultActionLink = this.defaultActionRowRight ? !this.row.get(this.defaultActionRowRight) : false;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.row || changes.columnIndex) {
            this.columnContent = this.row.getAt( this.columnIndex );
        }

        if ( changes.row || changes.defaultActionRowRight ) {
            this.disableDefaultActionLink = changes.defaultActionRowRight ? !this.row.get( this.defaultActionRowRight ) : false;
        }
    }

    public onBeforeNavigateDefaultRoute( ) {
        this.beforeNavigateDefaultRoute.emit( );
    }

    getDefaultActionToolTipForColumn( columnContent: string ) {
        if ( this.defaultActionToolTip ) {
            return this.uiService.translate( this.defaultActionToolTip, columnContent );
        }

        return this.uiService.translate( 'common.showOf', columnContent );
    }

}
